// extracted by mini-css-extract-plugin
export default {"message":"paypalbutton_message__BSvV7"};